import { BreakpointOptions } from '@presentation/types/shared'

export const breakpoints: BreakpointOptions = {
  mobile: 768,
  tablet: 992,
  desktop: 1200
}
